import React, { Component } from 'react';  
import { Toast } from 'antd-mobile/lib';
import { 
  checkNumber,
  getCheckNumber,
  checkSuccessData,
  getCheckSuccessData,
  smrzCheckCard,
  smrzCheckCardText,
  smrzCheckCardFlag,
  clearSmrzPassWord
} from '../../action/investmentAction.js';
import { connect } from 'react-redux';
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import Util from '../../util.js';

let time;

class CertificationCheckPhone extends Component {
  state = {
    checkCard: this.props.smrzCheckCard,
    cardVal: this.props.smrzCheckCardText,
    checkFlag: this.props.smrzCheckCardFlag,
    enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
  }

  componentWillMount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
    document.getElementsByTagName('title')[0].innerHTML = "实名认证";
  }

  getRandomInt = (min, max) => {
    return Math.floor(min + Math.random() * max);
  }

  goCertification = () => {
    let { dispatch, checkNumber } = this.props;
    let { checkCard } = this.state;
    let { savePicFun, actualControllerCity, actualBeneficiaryCity, mobileNo, name, certNo, certType, bankAccountShowNo, trustChannelId, bankCode, address, careerCode, cityCode, provinceCode, actualBeneficiary, actualController, actualBeneficiaryCertType, actualBeneficiaryCertNo, actualControllerCertType, actualControllerCertNo, officialsOrRelatives, annualIncomeV2,annualIncome,actualControllerBirthday,actualControllerValidTerm,actualControllerValidEver,actualControllerSex,actualControllerMobileNo,actualControllerProvince,actualControllerProfession,actualControllerAddress,actualControllerPostcode,actualControllerEmail,actualBeneficiaryValidTerm,actualBeneficiaryValidEver,actualBeneficiarySex,actualBeneficiaryBirthday,actualBeneficiaryMobileNo,actualBeneficiaryProvince,actualBeneficiaryAddress,actualBeneficiaryPostcode,actualBeneficiaryProfession,actualBeneficiaryEmail,conversationId,certLifeTime,certValidEver,certValidTerm } = this.props.location.state;
    let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
    if(checkNumber == null) {
      Toast.info( "请先获取验证码", 2);
    }else {
      dispatch(checkSuccessData(null));
      Toast.loading("正在加载", 2);
      dispatch(getCheckSuccessData({
        captcha: checkCard,
        authRequestNo: checkNumber.content.requestNo,
        bankProtocolVersion: this.props.location.state.bankProtocolVersion,
        upProtocolVersion: this.props.location.state.upProtocolVersion
      }, () => {
        dispatch(clearSmrzPassWord());
        hashHistory.push({
          pathname: "/certificationSetPassWord",
          state: {
            mobileNo: mobileNo,
            name: name,
            certNo: certNo,
            certType: certType,
            bankAccountShowNo: bankAccountShowNo,
            paymentChannelId: trustChannelId,
            bankCode: bankCode,
            authRequestNo: checkNumber.content.requestNo,
            businessType: "AddCard",
            bankAccountName: name,
            address: address,
            careerCode: careerCode,
            cityCode: cityCode,
            provinceCode: provinceCode,
            actualBeneficiary: actualBeneficiary,
            actualController: actualController,
            actualBeneficiaryCertType: actualBeneficiaryCertType,
            actualBeneficiaryCertNo: actualBeneficiaryCertNo,
            actualControllerCertType: actualControllerCertType,
            actualControllerCertNo: actualControllerCertNo,
            officialsOrRelatives: officialsOrRelatives, 
            callback: callback,
            route: route,
            enterType:this.state.enterType,
            annualIncomeV2:annualIncomeV2,
            annualIncome:annualIncome,
            actualControllerBirthday: actualControllerBirthday,
            actualControllerValidTerm: actualControllerValidTerm,
            actualControllerValidEver: actualControllerValidEver,
            actualControllerSex: actualControllerSex,
            actualControllerMobileNo: actualControllerMobileNo,
            actualControllerProvince: actualControllerProvince,
            actualControllerProfession: actualControllerProfession,
            actualControllerAddress: actualControllerAddress,
            actualControllerPostcode: actualControllerPostcode,
            actualControllerEmail: actualControllerEmail,
            actualBeneficiaryValidTerm: actualBeneficiaryValidTerm,
            actualBeneficiaryValidEver: actualBeneficiaryValidEver,
            actualBeneficiarySex: actualBeneficiarySex,
            actualBeneficiaryBirthday: actualBeneficiaryBirthday,
            actualBeneficiaryMobileNo: actualBeneficiaryMobileNo,
            actualBeneficiaryProvince: actualBeneficiaryProvince,
            actualBeneficiaryAddress: actualBeneficiaryAddress,
            actualBeneficiaryPostcode: actualBeneficiaryPostcode,
            actualBeneficiaryProfession: actualBeneficiaryProfession,
            actualBeneficiaryEmail: actualBeneficiaryEmail,
            actualBeneficiaryCity: actualBeneficiaryCity,
				    actualControllerCity: actualControllerCity,
            savePicFun: savePicFun,
            conversationId: conversationId,
            certLifeTime: certLifeTime,
						certValidEver: certValidEver,
						certValidTerm: certValidTerm,
          },
          query: {enterType:this.state.enterType,
						activityId:this.props.location.query.activityId}
        });
      }));
    }
  }

  changeCheckCard = (event) => {
    let { dispatch } = this.props;
    this.setState({
      checkCard :event.target.value
    })
    dispatch(smrzCheckCard(event.target.value));
  }

  goBack = () => {
    window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
    hashHistory.goBack();
  }

  getCheckCard = () => {
    let count = 119;
    let thisO = this;
    let { dispatch } = this.props;
    let { name, mobileNo, bankAccountShowNo, certNo, certType, trustChannelId } = this.props.location.state;
    Toast.loading();
    dispatch(checkNumber(null));
    dispatch(getCheckNumber({
      name: name,
      certNo: certNo,
      mobileNo: mobileNo,
      paymentChannelId: trustChannelId,
      bankAccountShowNo: bankAccountShowNo,
      clientType: Util.return_Clinet_Type()
    }, () => {
      if(time) {
        clearInterval(time)
      }
      thisO.setState({
        cardVal: "获取验证码",
        checkFlag: false
      })
    }));
    thisO.setState({
      cardVal: count + "秒后重发",
      checkFlag: true
    });
    // dispatch(smrzCheckCardText(count + "秒后重发"));
    // dispatch(smrzCheckCardFlag(true));
    time = setInterval(() => {
      count--;
      thisO.setState({
        cardVal: count + "秒后重发",
        checkFlag: true
      })
      // dispatch(smrzCheckCardText(count + "秒后重发"));
      // dispatch(smrzCheckCardFlag(true));
      if(count == 0) {
        clearInterval(time)
        thisO.setState({
          cardVal: "获取验证码",
          checkFlag: false
        })
        // dispatch(smrzCheckCardText(count + "秒后重发"));
        // dispatch(smrzCheckCardFlag(false));
      }
    }, 1000)
  }

  componentWillUnmount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
    clearInterval(time);
  }

  render() {
    let { checkNumber } = this.props;
    let { checkCard, checkFlag, cardVal } = this.state;
    return (
      <div className="mainBox"> 
          <NavigatorMain>
            <div className="boxHeader">
              <div>
                <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
              </div>
              <div>
                <span>实名认证</span>
              </div>
              <div>
                
              </div>
            </div>
          </NavigatorMain> 
          <div className="boxContent">
          <div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10}}>
            <div style={{fontSize: "13px", color: "#5b6370"}}>请输入您收到的短信验证码</div>
          </div>
          <div style={{
            height: 45,
            backgroundColor: "#fff",
            paddingLeft: 13,
            paddingRight: 13,
            overflow: "hidden",
            borderBottomWidth: 1,
            borderBottomColor: 'rgb(235, 238, 240)'
          }}>
            <span style={{
              color: "#5b6370",
              fontSize: "13px"
            }}>
              验证码
            </span>
            <input autocomplete="off"
            style={{
              height: 45,
              width: 150,
              fontSize: "13px",
              marginLeft: 10,
              color: "#3a3e47",
              verticalAlign: "middle"
            }}
            value={checkCard}
            onChange={this.changeCheckCard}
            placeholder="请输入验证码"
            />
            {
              checkFlag ? <div style={{
                display: "-webkit-flex",
                backgroundColor: "#afb0b2",
                height: 30,
                width: 90,
                WebkitJustifyContent: "center",
                WebkitAlignItems: "center",
                marginTop: 7.5,
                borderRadius: 30,
                float: "right"
              }}>
                <span style={{
                  color: "#5b6370",
                  fontSize: "13px"
                }}>{cardVal}</span>
              </div> :
              <div style={{
                display: "-webkit-flex",
                backgroundColor: "#fa063a",
                height: 30,
                width: 90,
                marginTop: 7.5,
                WebkitJustifyContent: "center",
                WebkitAlignItems: "center",
                borderRadius: 30,
                float: "right"
              }} onClick={this.getCheckCard}>
                <span style={{
                  color: "#fff",
                  fontSize: "13px"
                }}>获取验证码</span>
              </div>
            }
          </div>
          {
            checkCard != "" ?
            <div style={{
              display: "-webkit-flex",
              marginTop: 15,
              height: 40,
              backgroundColor: "#fa063a",
              WebkitJustifyContent: "center",
              WebkitAlignItems: "center",
              borderRadius: 30,
              marginLeft: 13,
              marginRight: 13,
              marginBottom: 15
            }}
            key={0}
            onClick={this.goCertification}
            >
              <div style={{color: "#fff", fontSize: 15}}>下一步</div>
            </div> :
            <div style={{
              display: "-webkit-flex",
              marginTop: 15,
              height: 40,
              backgroundColor: "#afb0b2",
              WebkitJustifyContent: "center",
              WebkitAlignItems: "center",
              borderRadius: 30,
              marginLeft: 13,
              marginRight: 13,
              marginBottom: 15
            }}
            key={0}
            >
              <div style={{color: "#fff", fontSize: 15}}>下一步</div>
            </div>
          }
        </div>
      </div>
    )
  }
}

function mapStateToProps(state,ownProps) {
  return {
    checkNumber: state.checkNumber,
    checkSuccessData: state.checkSuccessData,
    smrzCheckCard: state.smrzCheckCard,
    smrzCheckCardText: state.smrzCheckCardText,
    smrzCheckCardFlag: state.smrzCheckCardFlag
  }
}

export default connect(mapStateToProps)(CertificationCheckPhone);


// WEBPACK FOOTER //
// ./src/components/recommend/CertificationCheckPhone.js